<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center" style="gap: 0.5rem">
            <b-button-group class="add-button-group">
              <b-btn variant="primary" to="/manajer-file-asset/create">Tambah Data</b-btn>
            </b-button-group>
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="mb-3">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="6" md="3">
              <form-group-input
                ref="filter-file_description"
                type="text"
                v-model="filter.file_description"
                placeholder=""
                :need-label="true"
                label="Deskripsi"
                id="filter-file_description"
              />
            </b-col>
              <b-col cols="6" md="3">
                <form-group-input
                  ref="filter-tag"
                  type="enum"
                  :clearable="false"
                  :options="list.tag"
                  placeholder="Pilih Kategori"
                  :need-label="true"
                  label="Kategori"
                  v-model="filter.tag"
                  id="filter-year"
                />
              </b-col>
            <b-col cols="6" md="2">
              <label class="form-label">&nbsp;</label><br />
              <b-btn type="submit" class="btn-in-form" variant="primary">
                <font-awesome-icon icon="search" /><span>Cari</span>
              </b-btn>
              <b-btn
                type="button"
                @click.prevent="clearForm"
                variant="secondary"
                class="btn-in-form ml-2"
              >
                <font-awesome-icon icon="broom" /><span>Clear</span>
              </b-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table
      ref="dataTable"
      :delete-reason="false"
      :can-delete="true"
      :can-edit="false"
      :can-show="false"
      :data-url="apiUrl.schoolFileAsset"
      :data-columns="columns"
      :dataParams="dataParams"
      :defaultDataParams="this.filter"
    >
      <template slot="content_file_path" slot-scope="defaultSlotScope">
        <b-btn @click.prevent="openFilePreview(defaultSlotScope.colData.id)" >Preview</b-btn>
      </template>
      <template slot="content_tag" slot-scope="defaultSlotScope">
        <p class="m-0">{{ defaultSlotScope.colData.tag === 'pajak' ? 'Bukti Pajak' : 'Bukti Kwitansi' }}</p>
      </template>
    </paginated-table>
  </b-card>
</template>

<script>
import { objectToOptions } from "@/_helpers";
import paginatedTable from "@/components/PaginatedTable.vue";
import formGroupInput from "@/components/FormGroupInput.vue";
import SchoolFileAsset from "@/models/SchoolFileAsset.js";

const schoolFileAssetModel = new SchoolFileAsset();

export default {
  components: {
    formGroupInput,
    paginatedTable,
  },
  data() {
    return {
      isLoading: false,
      totalPromiseAreaCount: 0,
      apiUrl: {
        schoolFileAsset: schoolFileAssetModel.endpoint,
      },
      columns: [
        {
          prop: "file_description",
          label: "Deskripsi File",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "file_path",
          label: "File",
          // sortable: true,
          // resizable: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: "tag",
          label: "Kategori File",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
      ],
      list: {
        tag: objectToOptions({
          'kwitansi': 'Bukti Kwitansi',
          'pajak': 'Bukti Pajak',
        })
      },
      filter: {
        file_description: this.$route.query.file_description ?? null,
        tag: this.$route.query.tag ?? null,
      },
      dataParams: [
        'file_description',
        'tag'
      ],
    };
  },
  methods: {
    openFilePreview (id) {
      window.open('/file-preview/' + id, '_blank', 'toolbar=0,location=0,menubar=0')
    },
    clearForm() {
      this.$nextTick(() => {
        this.filter.file_description = null
        this.filter.tag = null
        setTimeout(() => {
          this.doFilter();
        }, 100);
      });
    },
    doFilter() {
      this.$refs.dataTable.doFilter(this.filter);
    },
  },
};
</script>